import { Component, OnInit, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { slideInUpStagger } from 'app/shared/animations/slide-in-up-stagger.animation';
import { DialogHelperService } from 'app/services/dialog-helper.service';

@Component({
  selector: 'app-asset-delete',
  templateUrl: './asset-delete.component.html',
  styleUrls: ['./asset-delete.component.scss'],
  animations: [
    slideInUpStagger('stagger-elem', '0.5rem', '.7', 'hoverOn')
  ]
})
export class AssetDeleteComponent implements OnInit {
  @HostBinding('@slideInUpStagger')
  @Input() status: string;
  @Input() asset: any;
  @Output() delete: EventEmitter<File> = new EventEmitter();

  constructor(private dialogHelper: DialogHelperService) { }

  onDelete(): void {
    this.dialogHelper.showConfirm(
      'Are you sure you want to delete',
      this.asset.displayName,
      'DELETE FILE',
      () => this.delete.emit(this.asset)
    );
  }

  ngOnInit() {
  }

}
